import { aget, apost, aFormPost } from '@/service'
import store from '@/store'

// 获取账户列表
export const getInvestAccount = (params: any) => {
  const userInfo = store.getters['moduleCommon/getUserInfo']
  return aFormPost('/tztapi/trade/fundBalance/tztInvestAccount/list', { adminId: userInfo?.id, ...params })
}

// 获取账户列表
export const tztInvestAccountFundBalance = (params: any) => {
  return aget('/tztapi/trade/fundBalance/tztInvestAccountFundBalance/list', params)
}

// 获取交易下单账户列表
export const getPurchaseInvestAccount = (params: any) => {
  return aget('/tztapi/trade/fundBalance/tztInvestAccountTrade/list', params)
}

// 获取账户列表
export const getInvestmentList = (params: any) => {
  return aget('/tztapi/trade/pfTrade/investmentList', params)
}

// 获取持仓明细
export const getAdminBalanceList = (params: any) => {
  return aget('/tztapi/trade/fundBalance/adminBalance/list', params, {
    _loading: true
  })
}

// 获取总持仓信息
export const getAdminBalanceSum = (params: any) => {
  return aget('/tztapi/trade/fundBalance/adminBalanceSum', params)
}

type dividendType = { fundId: number; tradeAcco: number; investAccountNo: number }
// 修改分红方式前置校验
export const getDividendType = (params: dividendType) => {
  return aget('/tztapi/trade/trade/check/dividendType', params)
}

// 持仓页产品下拉选项
export const getFundList = (params: any) => {
  return aget('/tztapi/trade/fundBalance/tztInvestAccount/fundList', params, { _loading: true })
}

// 查询对账单
export const getQueryStatement = (params: any) => {
  return aget('/tztapi/trade/tradeStatement/queryStatement', params, { _loading: true })
}

// 生成对账单
export const getGenerateStatement = (params: any) => {
  return aFormPost('/tztapi/trade/tradeStatement/generateStatement', params, { _loading: true })
}

// 交易订单待办审核
export const tradeCheck = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/tradeCheck', params)
}

// 分页查询交易待办列表
export const selectTradePendingPages = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/selectTradePendingPages', params, {
    _loading: true,
    _minLoadingDuration: 400
  })
}

// 查询交易订单的审核待办
export const selectTradeCheckPending = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/selectTradeCheckPending', params)
}

// 待办提醒
export const notice = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/notice', params)
}

// 待办数量
export const pengdingCount = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/pengdingCount', params)
}

// 生成交易订单待办批量审核
export const tradeCheckBatch = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/tradeCheckBatch', params)
}

// 导出数据 -- 持仓明细
export const getAdminBalanceExport = (params: any) => {
  return aget('/tztapi/trade/fundBalance/adminBalance/export', params)
}

// 导出数据 -- 待办事项
export const getExportTradePendingPages = (params: any) => {
  return apost('/tztapi/trade/tradeaccoMode/exportTradePendingPages', params)
}
